import { formatMoney } from '../../../shared/money/exact-money.js';
function formatDate(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '-';
  }

  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) {
    return raw;
  }

  return date.toLocaleString();
}

function formatFinanceValue(value, locale) {
  return formatMoney(value, locale, { fallback: '-', trimTrailingZeros: true });
}

function buildSyncFreshness(value, labelValue = value) {
  const label = formatDate(labelValue);
  const date = new Date(String(value || '').trim());
  if (Number.isNaN(date.getTime())) {
    return {
      lastSuccessfulSyncAt: label,
      lastSyncStatus: 'stale',
      lastSyncTitle: `Last Sync: ${label}`,
    };
  }

  const ageMs = Date.now() - date.getTime();
  const lastSyncStatus = ageMs < 60 * 1000
    ? 'fresh'
    : ageMs < 10 * 60 * 1000
      ? 'warning'
      : 'stale';

  return {
    lastSuccessfulSyncAt: label,
    lastSyncStatus,
    lastSyncTitle: `Last Sync: ${label}`,
  };
}

export function buildAccountsTableModel(dtoRows, locale) {
  return dtoRows.map((row) => {
    const syncFreshness = buildSyncFreshness(
      row.lastSyncFreshnessAt || row.lastSuccessfulSyncAt,
      row.lastSuccessfulSyncAt,
    );

    return {
      key: row.key,
      accountId: row.accountId,
      login: row.login,
      accountNumber: row.accountNumber,
      type: row.type,
      platform: row.platform,
      currency: row.currency,
      leverage: row.leverage,
      balance: formatFinanceValue(row.balance, locale),
      equity: formatFinanceValue(row.equity, locale),
      freeMargin: formatFinanceValue(row.freeMargin, locale),
      usedMargin: formatFinanceValue(row.usedMargin, locale),
      lastSuccessfulSyncAtRaw: row.lastSuccessfulSyncAt || null,
      lastSyncFreshnessAtRaw: row.lastSyncFreshnessAt || row.lastSuccessfulSyncAt || null,
      ...syncFreshness,
      profileUid: row.profileUid,
      profileStatus: row.profileStatus,
      profileName: row.profileName,
      createdAt: formatDate(row.created),
      isPendingVerification: Boolean(row.isPendingVerification),
      source: row.source,
    };
  });
}
